import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

const SITE = "https://reflectumpellicule.com";

// Sets a unique, bilingual document title + meta description + canonical per page.
export function usePageMeta(pageKey) {
  const { t, lang } = useLanguage();
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = t(`meta.pages.${pageKey}`);
    if (!meta) return;
    document.title = meta.title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", meta.desc);
    const canonical = document.querySelector('link[rel="canonical"]');
    const clean = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    if (canonical) {
      canonical.setAttribute("href", `${SITE}${clean}`);
    }
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", meta.title);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute("content", meta.desc);
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", `${SITE}${clean}`);
  }, [pageKey, lang, pathname]);
}
